<div class="grid-container">
<div class='iana-staff-footer'>
  <div class="grid-x">
    <div class="cell large-12 small-12" style="display: flex; justify-content: flex-end">
      <a class="a-link-no-underline" target="_blank" href="https://www.icann.org/privacy">Privacy Policy and Terms of Service</a>
    </div>
  </div>
</div>
</div>
